<nav class="topbar">
  <button class="icon-button mobile-menu-button" type="button" title="Меню" aria-label="Меню" (click)="toggleSidebar.emit()">
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16"/><path d="M4 12h16"/><path d="M4 18h16"/></svg>
  </button>

  <div class="topbar-brand">
    <span class="brand-mark">IP</span>
    <div>
      <strong>IcePass</strong>
      <span>Dashboard</span>
    </div>
  </div>

  <div class="topbar-actions">
    <button class="icon-button" type="button" [attr.title]="themeTitle" [attr.aria-label]="themeTitle" (click)="toggleTheme()">
      <svg *ngIf="theme === 'light'" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3a6 6 0 0 0 9 7 9 9 0 1 1-9-7Z"/></svg>
      <svg *ngIf="theme === 'dark'" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/></svg>
    </button>

    <div class="topbar-menu">
      <button class="icon-button notification-button" type="button" title="Уведомления" aria-label="Уведомления" (click)="toggleNotifications()">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 7h18s-3 0-3-7"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
        <span aria-hidden="true" *ngIf="unreadNotificationsCount > 0"></span>
      </button>

      <div class="dropdown-panel notification-panel" *ngIf="notificationsOpen">
        <div class="dropdown-heading">
          <div>
            <strong>Оповещения</strong>
            <small *ngIf="unreadNotificationsCount > 0">{{ unreadNotificationsCount }} новых</small>
          </div>
          <button class="heading-action" type="button" *ngIf="unreadNotificationsCount > 0" (click)="markAllNotificationsAsRead()">Прочитано</button>
        </div>

        <ng-container *ngIf="notifications.length > 0; else emptyNotifications">
          <div class="notification-item" *ngFor="let notification of recentNotifications" [class.unread]="!notification.read" (click)="markNotificationAsRead(notification)">
            <span
              class="dot"
              [class.green]="notification.kind === 'client' || notification.kind === 'order'"
              [class.blue]="notification.kind === 'event' || notification.kind === 'mailing' || notification.kind === 'telegram'"
              [class.amber]="notification.kind === 'system' || notification.kind === 'finance'"
              [class.violet]="notification.kind === 'kanban' || notification.kind === 'directory'"
            ></span>
            <span class="notification-content">
              <strong>{{ notification.title }}</strong>
              <em>{{ notification.actor }} - {{ notification.description }}</em>
            </span>
            <small>{{ formatRelativeTime(notification.createdAt) }}</small>
          </div>
          <button class="show-all-notifications" type="button" (click)="openNotificationsPage()">Все оповещения</button>
        </ng-container>

        <ng-template #emptyNotifications>
          <div class="empty-notifications">Событий пока нет.</div>
        </ng-template>
      </div>
    </div>

    <div class="topbar-menu">
      <button class="profile-button" type="button" title="Профиль" aria-label="Профиль" (click)="toggleProfile()">
        <span class="avatar">А</span>
        <span class="profile-copy">
          <strong>Администратор</strong>
          <small>IcePass</small>
        </span>
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
      </button>

      <div class="dropdown-panel profile-panel" *ngIf="profileOpen">
        <a routerLink="/dashboard/profile" (click)="closeMenus()">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 21a8 8 0 1 0-16 0"/><circle cx="12" cy="7" r="4"/></svg>
          <span>Профиль</span>
        </a>
        <a routerLink="/dashboard/settings" (click)="closeMenus()">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12.22 2h-.44a2 2 0 0 0-2 2l-.11.67a2 2 0 0 1-2.95 1.21l-.56-.36a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.56.36a2 2 0 0 1 0 3.46l-.56.36a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.56-.36a2 2 0 0 1 2.95 1.21l.11.67a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2l.11-.67a2 2 0 0 1 2.95-1.21l.56.36a2 2 0 0 0 2.73-.73l.22-.38a2 2 0 0 0-.73-2.73l-.56-.36a2 2 0 0 1 0-3.46l.56-.36a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.56.36a2 2 0 0 1-2.95-1.21L14.22 4a2 2 0 0 0-2-2Z"/><circle cx="12" cy="12" r="3"/></svg>
          <span>Настройки</span>
        </a>
        <button type="button" (click)="logout()">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="m16 17 5-5-5-5"/><path d="M21 12H9"/></svg>
          <span>Выйти</span>
        </button>
      </div>
    </div>
  </div>
</nav>
